module.exports = __webpack_public_path__ + "img/question-circle.52344f9f.svg";